import React from 'react';
import {shape, string, number, bool, func} from 'prop-types';
import {Link} from 'react-router-dom';
import {Segment, Image, Icon, Grid} from 'semantic-ui-react';
import capitalize from 'lodash/capitalize';
import {makeDBUGCImageUrl, formatDate} from 'utils/DBUtils';

const UGCSubmission = props => {
  const challengeLink = <Link to={`/break/${props.challengeId}/edit`}>{props.challengeId}</Link>;
  const imageUrl = makeDBUGCImageUrl(props.assetId);
  return (
    <div className='ugc-submission'>
      <Segment raised>
        <div className='ugc-submission-favorite'>
          {props.favorite
            ? <Icon color='yellow' name='star' size='big' onClick={props.unfavoriteSubmission} />
            : <Icon link disabled name='star outline' size='large' onClick={props.favoriteSubmission} />
          }
        </div>
        <Image src={imageUrl} />
        <p>
          <span>{props.firstName} {props.lastName} ({props.userId})</span>
          <span>Shares: {props.numShares}</span>
          <span>Uploaded from {challengeLink}</span>
          <span>Platform: {capitalize(props.platform)}</span>
          <span>Created: {formatDate(props._created, 'MMMM Do YYYY, h:mm:ss a')}</span>
          <span>Approved: {String(props.approved)}</span>
          {props.utmSource && <span>Source: {props.utmSource}</span>}
          {props.utmContent && <span>UTM Content: {props.utmContent}</span>}
        </p>
        <div className='ugc-submission-actions'>
          <Grid>
            <Grid.Column verticalAlign='middle' width={2}>
              {/* download attribute not working right now, maybe due to cross origin images */}
              <a download={"ugc-image.png"} target="_blank" href={imageUrl}>
                <Icon name='download' size='large' />
              </a>
            </Grid.Column>
            <Grid.Column verticalAlign='middle' width={5}>
              {props.approved
                ? <a onClick={props.unapproveSubmission}>Unapprove</a>
                : <a onClick={props.approveSubmission}>Approve</a>
              }
            </Grid.Column>
            <Grid.Column verticalAlign='middle' width={1} floated='right'>
              <Icon link name='trash alternate outline' color='red' size='large' onClick={props.deleteSubmission} />
            </Grid.Column>
          </Grid>
        </div>
      </Segment>
    </div>
  );
};

export const UGCSubmissionPropType = shape({
  assetId: string.isRequired,
  challengeId: string.isRequired,
  firstName: string,
  lastName: string,
  userId: string.isRequired,
  numShares: number,
  platform: string.isRequired,
  approved: bool.isRequired,
  favorite: bool,
  _created: number.isRequired,
  utmSource: string,
  approveSubmission: func.isRequired,
  unapproveSubmission: func.isRequired,
  deleteSubmission: func.isRequired,
  favoriteSubmission: func.isRequired,
  unfavoriteSubmission: func.isRequired,
});

UGCSubmission.propTypes = UGCSubmissionPropType;

UGCSubmission.defaultProps = {
  numShares: 0,
  favorite: false
};

export default UGCSubmission;



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/UGCSubmission.jsx